import { observer } from 'mobx-react';
import { DividerContainer } from './styles';

const Divider = ({
  className,
  dividerText,
  upperCase = true,
}: {
  className: string;
  dividerText: string;
  upperCase?: boolean;
}): React.ReactElement => {
  const generateCustomDividerText = () => {
    if (!dividerText) {
      return 'OR';
    }
    return upperCase ? dividerText?.toUpperCase() : dividerText;
  };
  const customDividerText = generateCustomDividerText();
  return (
    <DividerContainer className={className}>
      <div className="divider">
        <span>{customDividerText}</span>
      </div>
    </DividerContainer>
  );
};

export default observer(Divider);
